import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip as RechartsTooltip, ReferenceLine, Cell } from "recharts";
import { CumulativeTooltip } from "./CumulativeTooltip";

export function CumulativeInvestmentChart({
                                              data,
                                              breakEvenYear,
                                              paybackMonths
                                          }: {
    data: any[];
    breakEvenYear?: number | null;
    paybackMonths?: number | null;
}) {
    return (
        <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={data} margin={{ top: 40, right: 30, left: 20, bottom: 20 }}>
                <CartesianGrid strokeDasharray="2 4" stroke="#FFFFFF" opacity={0.2} vertical={false} />
                <XAxis dataKey="year" stroke="#FFFFFF" fontSize={14} fontWeight={600}
                       tickLine={{ stroke: "#FFFFFF", strokeWidth: 1 }}
                       axisLine={{ stroke: "#FFFFFF", strokeWidth: 1 }} />
                <YAxis stroke="#FFFFFF" fontSize={14} fontWeight={600}
                       tickFormatter={(v) => `$${(v/1_000_000).toFixed(1)}M`}
                       tickLine={{ stroke: "#FFFFFF", strokeWidth: 1 }}
                       axisLine={{ stroke: "#FFFFFF", strokeWidth: 1 }} />
                <RechartsTooltip content={<CumulativeTooltip />} />

                <Bar dataKey="investment" fill="#FFFFFF" name="investment" radius={[6,6,0,0]}>
                    {data.map((_, i) => <Cell key={i} fill="#3B82F6" />)}
                </Bar>
                <Bar dataKey="savings" fill="#FFFFFF" name="savings" radius={[6,6,0,0]}>
                    {data.map((_, i) => <Cell key={i} fill="#1A9B8A" />)}
                </Bar>
                <Line type="monotone" dataKey="cumulativeValue" stroke="#FFFFFF" strokeWidth={2}
                      dot={{ fill: '#FFFFFF', r: 6, strokeWidth: 3, stroke: '#FFFFFF' }}
                      name="cumulativeValue" />

                {breakEvenYear && breakEvenYear <= 5 && (
                    <ReferenceLine x={`Year ${breakEvenYear}`} stroke="#f59e0b" strokeDasharray="8 4" strokeWidth={2}
                                   label={{ value: `Breakeven: ${paybackMonths?.toFixed(1)} months`, position: 'insideTopRight', fontSize: 11, fill: '#f59e0b', fontWeight: 'bold' }} />
                )}
            </ComposedChart>
        </ResponsiveContainer>
    );
}